export interface ICountry {
  names: {
    common: string;
    official: string;
    alternates: string[];
    native: { [key: string]: { official: string; common: string } };
    translations: { [key: string]: { official: string; common: string } };
  };
  codes: {
    alpha_2: string;
    alpha_3: string;
    ccn3: string;
    cioc: string;
    fifa: string;
    fips: string;
    gec: string;
  };
  flag: {
    emoji: string;
    url_svg: string;
    url_png: string;
    description: string;
    unicode: string;
    html_entity: string;
  };
  capitals: Array<{
    name: string;
    coordinates: { lat: number; lng: number };
    attributes: {
      primary: boolean;
      constitutional: boolean;
      administrative: boolean;
      executive: boolean;
      legislative: boolean;
      judicial: boolean;
    };
  }>;
  region: string;
  subregion: string;
  continents: string[];
  landlocked: boolean;
  borders: string[];
  population: number;
  area: {
    kilometers: number;
    miles: number;
  };
  coordinates: {
    lat: number;
    lng: number;
  };
  timezones: string[];
  languages: Array<{
    iso639_1: string;
    iso639_2b: string;
    iso639_2t: string;
    iso639_3: string;
    bcp47: string;
    name: string;
    native_name: string;
  }>;
  currencies: Array<{
    code: string;
    name: string;
    symbol: string;
  }>;
  tlds: string[];
  calling_codes: string[];
  cars: {
    driving_side: string;
    signs: string[];
  };
  postal_code: {
    format: string;
    regex: string;
  };
  demonyms: { [key: string]: { f: string; m: string } };
  date: {
    start_of_week: string;
  };
  economy: {
    gini_coefficient: { [year: string]: number };
  };
  classification: {
    sovereign: boolean;
    un_member: boolean;
    iso_status: string;
    disputed: boolean;
    dependency: boolean;
    dependency_type: string;
    un_observer: boolean;
  };
  links: {
    google_maps: string;
    open_street_maps: string;
    official: string;
    wikipedia: string;
  };
}

export enum Region {
  "ALL" = "all",
  "AFRICA" = "africa",
  "AMERICAS" = "americas",
  "ASIA" = "asia",
  "EUROPE" = "europe",
  "OCEANIA" = "oceania",
}